import { Button } from "@/components/ui/button";

interface ValidationButtonProps {
  isSubmitting: boolean;
  isDisabled: boolean;
  lastValidatedAmount: number | null;
  onValidate: () => void;
}

export const ValidationButton = ({
  isSubmitting,
  isDisabled,
  lastValidatedAmount,
  onValidate,
}: ValidationButtonProps) => {
  return (
    <Button
      onClick={onValidate}
      disabled={isSubmitting || isDisabled}
      className="w-full bg-green-600 hover:bg-green-700"
    >
      {isSubmitting 
        ? "Validation..." 
        : lastValidatedAmount === null 
          ? "Valider le montant"
          : "Valider les nouvelles transactions"
      }
    </Button>
  );
};